function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconNewUserFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 21.867V5.003l6 3.6V6.27L9.029 3.288A1.981 1.981 0 008.004 3C6.96 3 6 3.833 6 5.003v16.864a2 2 0 00.971 1.716L14 27.8v-2.332l-6-3.6zM23.996 3c-.343 0-.695.09-1.025.288L16 7.471V29l9.029-5.417A2 2 0 0026 21.867V5.003C26 3.833 25.04 3 23.996 3z",
    fill: props.color
  }));
}

export default SvgIconNewUserFilled;